// @flow
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FocusedImage from 'Components/FocusedImage';
import { Container, Row, Col } from 'Components/Grid';
import AssetModel from 'Stores/AssetModel';
import styles from './compact.scss';
import classNames from 'classnames/bind';
import CallToAction from 'Components/CallToAction';
import ConsumptionData from 'Components/ConsumptionData';
import Typography, { headlinePropTypes } from 'Components/Typography';
import { lowerCase6e } from 'Utils/special/lowerCaseSpecial';
import { ctaPropTypes } from 'Components/CallToAction';
import { withRouter } from 'react-router-dom';
import { Watch } from 'scrollmonitor-react';

const cx = classNames.bind(styles);

const HeroHeaderCompact = ({
  consumptionText,
  contentAlignment,
  cta1,
  deeplinkId,
  headline,
  image,
  isInViewport = true,
  onOpenContact,
  stopWatcher = () => {},
  subHeader,
}) => {
  const imageAsset = new AssetModel(image);

  const className = cx('hero-header-compact', {
    inView: window.isPreview || isInViewport,
  });

  useEffect(() => {
    if (isInViewport) {
      stopWatcher();
    }
  }, [isInViewport, stopWatcher]);

  return (
    <div className={className} id={deeplinkId}>
      <div className={styles.image}>
        <FocusedImage
          image={Object.assign(imageAsset, { dim: headline.value ? 0.3 : undefined })}
          useThumb={imageAsset && imageAsset.shouldUseThumb()}
          imageMobile={false}
        />

        <div className={styles.container}>
          <Container style={{ width: '100%' }}>
            <div
              className={cx('compactContent', {
                alignLeft: contentAlignment === 'left',
                alignCenter: contentAlignment === 'center',
                alignRight: contentAlignment === 'right',
              })}
            >
              {subHeader && (
                <div
                  className={styles.subtitle}
                  dangerouslySetInnerHTML={{ __html: lowerCase6e(subHeader) }}
                />
              )}
              {headline && (
                <Typography.Headline
                  {...headline}
                  className={styles.headline}
                  additionalAriaLabelText={consumptionText}
                />
              )}
              {cta1 && cta1.label && (
                <div className={styles.cta}>
                  <CallToAction {...cta1} onOpenContact={onOpenContact} light={true} />
                </div>
              )}
            </div>
          </Container>
        </div>
      </div>

      <div className={styles.content}>
        <Row align="center">
          <Col cols={12} m={10} l={8}>
            {subHeader && (
              <div
                className={styles.subtitle}
                dangerouslySetInnerHTML={{ __html: lowerCase6e(subHeader) }}
                aria-hidden={true}
              />
            )}
            {headline && headline.value && (
              <Typography.Headline
                {...headline}
                className={styles.headline}
                additionalProps={{ 'aria-hidden': true }}
                additionalAriaLabelText={consumptionText}
              />
            )}
            {cta1 && cta1.label && (
              <div className={styles.cta}>
                <CallToAction {...cta1} tabindex="-1" />
              </div>
            )}
          </Col>
        </Row>
      </div>
      {consumptionText && <ConsumptionData consumptionText={[consumptionText]} />}
    </div>
  );
};

HeroHeaderCompact.propTypes = {
  consumptionText: PropTypes.string,
  contentAlignment: PropTypes.oneOf(['left', 'right']),
  cta1: PropTypes.shape(ctaPropTypes),
  deeplinkId: PropTypes.number,
  headline: PropTypes.shape(headlinePropTypes),
  image: PropTypes.object,
  isInViewport: PropTypes.bool,
  onOpenContact: PropTypes.func,
  stopWatcher: PropTypes.func,
  subHeader: PropTypes.string,
};

export default withRouter(Watch(HeroHeaderCompact));
